import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { theme } from "../../utils/global-styles/theme";
import LeftSliderArrow from "../shared/SliderOverlay/Icons/LeftSliderArrow";
import RightSliderArrow from "../shared/SliderOverlay/Icons/RightSliderArrow";
import BioCard from "./BioCard";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const FeaturedInThisCourse = ({
  aboutTheInstructorsTitle,
  instructorsInfo,
}) => {
  const Container = styled.section`
      display: grid;
      grid-template: 0fr 420px / auto 915px auto;
      margin-bottom: 10em;

      @media only screen and (max-width: ${theme.breakpoints.mobile}) {
        display: block;
      }

      @media only screen and (min-width: ${theme.breakpoints
          .tabletUp}) and (max-width: ${theme.breakpoints.tabletLandscapeUp}) {
        display: none;
      }
    `,
    TabletContainer = styled.section`
      display: none;
      @media only screen and (min-width: ${theme.breakpoints
          .tabletUp}) and (max-width: ${theme.breakpoints.tabletLandscapeUp}) {
        display: grid;
        grid-template: 0fr 462px / auto 670px auto;
        margin: 5em 0;
      }
    `,
    Header = styled.h1`
      grid-area: 1 / 1 / span 1 / span 3;
      padding: 0 100px;
      padding-bottom: 40px;
      @media only screen and (max-width: ${theme.breakpoints.mobile}) {
        padding: 0 40px;
      }
    `,
    LeftArrowContainer = styled.div`
      grid-area: 2 / 1 / 2 / 1;
      display: flex;
      justify-content: right;
      align-items: center;
      @media only screen and (max-width: ${theme.breakpoints.mobile}) {
        display: none;
      }
    `,
    RightArrowContainer = styled.div`
      grid-area: 2 / 3 / 2 / 3;
      display: flex;
      justify-content: left;
      align-items: center;
      @media only screen and (max-width: ${theme.breakpoints.mobile}) {
        display: none;
      }
    `,
    BioCarouselContainer = styled.div`
      grid-area: 2 / 2 / 2 / 2;
      display: grid;
      grid-template-columns: repeat(3, 1fr);

      @media only screen and (max-width: ${theme.breakpoints.mobile}) {
        display: block;
      }
      @media only screen and (min-width: ${theme.breakpoints
          .tabletUp}) and (max-width: ${theme.breakpoints.tabletLandscapeUp}) {
        display: none;
      }
    `,
    TabletCarouselContainer = styled.div`
      display: none;

      @media only screen and (min-width: ${theme.breakpoints
          .tabletUp}) and (max-width: ${theme.breakpoints.tabletLandscapeUp}) {
        grid-area: 2 / 2 / 2 / 2;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
      }
    `,
    BioCardsWrapper = styled.div`
      width: 100%;
      display: flex;
      flex-direction: column;
      padding-bottom: 66px;
    `,
    CardContainer = styled.div`
      display: flex;
      flex-direction: row;
      width: 100%;

      @media only screen and (max-width: ${theme.breakpoints.mobile}) {
        flex-direction: column;
      }
    `,
    StyledImg = styled(GatsbyImage)`
      display: block;
      width: 40%;

      @media only screen and (max-width: ${theme.breakpoints.mobile}) {
        width: 100%;
        height: 267px;
      }

      @media only screen and (min-width: ${theme.breakpoints
          .tabletUp}) and (max-width: ${theme.breakpoints.tabletLandscapeUp}) {
        height: 333px;
      }
    `,
    DetailsContainer = styled.div`
      display: block;
      width: 60%;
      padding-top: 85px;
      padding-left: 73px;
      padding-right: 73px;
      padding-bottom: 73px;

      @media only screen and (max-width: ${theme.breakpoints.mobile}) {
        width: 100%;
        padding-top: 45px;
        padding-left: 35px;
        padding-right: 35px;
        padding-bottom: 35px;
      }
    `,
    InstructorName = styled.h5`
      font-family: ${theme.fontFaces.headers};
      margin-bottom: 55px;
      font-weight: bold;
      color: ${theme.colors.black};
      @media only screen and (max-width: ${theme.breakpoints.mobile}) {
        font-weight: bold;
        margin-bottom: 10px;
      }

      @media only screen and (min-width: ${theme.breakpoints
          .tabletUp}) and (max-width: ${theme.breakpoints.tabletLandscapeUp}) {
        font-size: 37px;
        line-height: 40px;
      }
    `,
    InstructorDescription = styled.h5`
      font-family: ${theme.fontFaces.headers};
      color: ${theme.colors.black};
      @media only screen and (max-width: ${theme.breakpoints.iPadPro}) {
        margin-bottom: 10px;
        font-size: 20px;
        line-height: 29px;
      }
    `,
    DesktopAndMobile = styled.div`
      display: block;
      @media only screen and (min-width: ${theme.breakpoints
          .tabletUp}) and (max-width: ${theme.breakpoints.tabletLandscapeUp}) {
        display: none;
      }
    `,
    Tablet = styled.div`
      display: none;
      @media only screen and (min-width: ${theme.breakpoints
          .tabletUp}) and (max-width: ${theme.breakpoints.tabletLandscapeUp}) {
        display: block;
      }
    `,
    [currentStartIndex, setCurrentStartIndex] = useState(0),
    [isMobileView, setMobileView] = useState(false),
    handleResize = () => {
      window.innerWidth <= 600 ? setMobileView(true) : setMobileView(false);
    };

  useEffect(() => {
    if (typeof window !== "object") {
      return false;
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });
  const showBioCards = (isTablet = false) => {
      if (isMobileView) {
        return instructorsInfo.map((bio, index) => {
          return (
            <BioCard
              tabIndex="0"
              name={bio.name}
              title={bio?.sectionTitle || ""}
              backgroundColor={index % 2 === 1 ? "primary-bg" : "royalblue-bg"}
              image={bio.photoLogo}
              key={index}
            />
          );
        });
      } else {
        const slidesPerPage = isTablet ? 2 : 3;
        return instructorsInfo
          .slice(currentStartIndex, currentStartIndex + slidesPerPage)
          .map((bio, index) => {
            return (
              <BioCard
                tabIndex="0"
                name={bio.name}
                title={bio?.sectionTitle || ""}
                backgroundColor={index === 1 ? "primary-bg" : "royalblue-bg"}
                image={bio.photoLogo}
                key={index}
              />
            );
          });
      }
    },
    handleLeftArrowClick = (isTablet = false) => {
      const contentMultiple = isTablet ? 2 : 3;
      currentStartIndex - contentMultiple >= 0
        ? setCurrentStartIndex(currentStartIndex - contentMultiple)
        : setCurrentStartIndex(instructorsInfo.length - contentMultiple);
    },
    handleRightArrowClick = (isTablet = false) => {
      const contentMultiple = isTablet ? 2 : 3;
      currentStartIndex + contentMultiple < instructorsInfo.length
        ? setCurrentStartIndex(currentStartIndex + contentMultiple)
        : setCurrentStartIndex(0);
    },
    sectionHeader = aboutTheInstructorsTitle,
    splitHeader = aboutTheInstructorsTitle.split(" "),
    firstPartOfHeader = splitHeader.shift();

  return (
    <>
      <DesktopAndMobile>
        {instructorsInfo.length >= 3 ? (
          <Container>
            <Header>
              {firstPartOfHeader} <br /> {splitHeader.join(" ")}
            </Header>
            {instructorsInfo.length > 3 && (
              <>
                <LeftArrowContainer>
                  <LeftSliderArrow
                    arrowBgColorClassName={"light"}
                    handleArrowClick={() => handleLeftArrowClick(false)}
                  />
                </LeftArrowContainer>
                <RightArrowContainer>
                  <RightSliderArrow
                    arrowBgColorClassName={"light"}
                    handleArrowClick={() => handleRightArrowClick(false)}
                  />
                </RightArrowContainer>
              </>
            )}

            <BioCarouselContainer>{showBioCards()}</BioCarouselContainer>
          </Container>
        ) : instructorsInfo.length == 2 ? (
          <BioCardsWrapper>
            <Header>
              {firstPartOfHeader} <br /> {splitHeader.join(" ")}
            </Header>
            <CardContainer>
              <StyledImg
                image={getImage(instructorsInfo[0]?.photoLogo.gatsbyImageData)}
              />
              <DetailsContainer className="primary-bg white">
                <InstructorName>{instructorsInfo[0].name}</InstructorName>
                <InstructorDescription>
                  {instructorsInfo[0].sectionTitle || ""}
                </InstructorDescription>
              </DetailsContainer>
            </CardContainer>

            <CardContainer>
              {isMobileView ? (
                <>
                  <StyledImg
                    image={getImage(
                      instructorsInfo[1]?.photoLogo.gatsbyImageData
                    )}
                  />
                  <DetailsContainer className="secondary-bg main">
                    <InstructorName>{instructorsInfo[1].name}</InstructorName>
                    <InstructorDescription>
                      {instructorsInfo[1].sectionTitle || ""}
                    </InstructorDescription>
                  </DetailsContainer>
                </>
              ) : (
                <>
                  <DetailsContainer className="secondary-bg main">
                    <InstructorName>{instructorsInfo[1].name}</InstructorName>
                    <InstructorDescription>
                      {instructorsInfo[1].sectionTitle || ""}
                    </InstructorDescription>
                  </DetailsContainer>
                  <StyledImg
                    image={getImage(
                      instructorsInfo[1]?.photoLogo.gatsbyImageData
                    )}
                  />
                </>
              )}
            </CardContainer>
          </BioCardsWrapper>
        ) : (
          <BioCardsWrapper>
            <Header>
              {firstPartOfHeader} <br /> {splitHeader.join(" ")}
            </Header>
            <CardContainer>
              <StyledImg
                image={getImage(instructorsInfo[0]?.photoLogo.gatsbyImageData)}
              />
              <DetailsContainer className="primary-bg white">
                <InstructorName>{instructorsInfo[0].name}</InstructorName>
                <InstructorDescription>
                  {instructorsInfo[0].sectionTitle || ""}
                </InstructorDescription>
              </DetailsContainer>
            </CardContainer>
          </BioCardsWrapper>
        )}
      </DesktopAndMobile>

      <Tablet>
        {instructorsInfo.length > 3 ? (
          <TabletContainer>
            <Header>
              {firstPartOfHeader} <br /> {splitHeader.join(" ")}
            </Header>
            {instructorsInfo.length > 2 && (
              <>
                <LeftArrowContainer>
                  <LeftSliderArrow
                    arrowBgColorClassName={"light"}
                    handleArrowClick={() => handleLeftArrowClick(true)}
                  />
                </LeftArrowContainer>
                <RightArrowContainer>
                  <RightSliderArrow
                    arrowBgColorClassName={"light"}
                    handleArrowClick={() => handleRightArrowClick(true)}
                  />
                </RightArrowContainer>
              </>
            )}
            <TabletCarouselContainer>
              {showBioCards(true)}
            </TabletCarouselContainer>
          </TabletContainer>
        ) : instructorsInfo.length == 2 ? (
          <BioCardsWrapper>
            <Header>
              {firstPartOfHeader} <br /> {splitHeader.join(" ")}
            </Header>
            <CardContainer>
              <StyledImg
                image={getImage(instructorsInfo[0]?.photoLogo.gatsbyImageData)}
              />
              <DetailsContainer className="primary-bg white">
                <InstructorName>{instructorsInfo[0].name}</InstructorName>
                <InstructorDescription>
                  {instructorsInfo[0].sectionTitle || ""}
                </InstructorDescription>
              </DetailsContainer>
            </CardContainer>

            <CardContainer>
              {isMobileView ? (
                <>
                  <StyledImg
                    image={getImage(
                      instructorsInfo[1]?.photoLogo.gatsbyImageData
                    )}
                  />
                  <DetailsContainer className="light-bg main">
                    <InstructorName>{instructorsInfo[1].name}</InstructorName>
                    <InstructorDescription>
                      {instructorsInfo[1].sectionTitle || ""}
                    </InstructorDescription>
                  </DetailsContainer>
                </>
              ) : (
                <>
                  <DetailsContainer className="light-bg main">
                    <InstructorName>{instructorsInfo[1].name}</InstructorName>
                    <InstructorDescription>
                      {instructorsInfo[1].sectionTitle || ""}
                    </InstructorDescription>
                  </DetailsContainer>
                  <StyledImg
                    image={getImage(
                      instructorsInfo[1]?.photoLogo.gatsbyImageData
                    )}
                  />
                </>
              )}
            </CardContainer>
          </BioCardsWrapper>
        ) : (
          <BioCardsWrapper>
            <Header>
              {firstPartOfHeader} <br /> {splitHeader.join(" ")}
            </Header>
            <CardContainer>
              <StyledImg
                image={getImage(instructorsInfo[0]?.photoLogo.gatsbyImageData)}
              />
              <DetailsContainer className="primary-bg white">
                <InstructorName>{instructorsInfo[0].name}</InstructorName>
                <InstructorDescription>
                  {instructorsInfo[0].sectionTitle || ""}
                </InstructorDescription>
              </DetailsContainer>
            </CardContainer>
          </BioCardsWrapper>
        )}
      </Tablet>
    </>
  );
};

FeaturedInThisCourse.propTypes = {
  aboutTheInstructorsTitle: PropTypes.string,
  instructorsInfo: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      sectionTitle: PropTypes.string,
      bioAbout: PropTypes.shape({
        bioAbout: PropTypes.string,
      }),
      photoLogo: PropTypes.shape({
        fluid: PropTypes.shape({
          srcSet: PropTypes.string,
        }),
      }),
    })
  ),
};

export default FeaturedInThisCourse;
